let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6idhL")).then(() => parcelRequire('azam2'));